import { SHOP_STATUS, SHOP_TYPE } from '../../types/enum'

export const ALPHA_PLAN_SPU_CODE = 'CC279730'
export const DEFAULT_EMPLOYEE = 1
export const AGENT_ACCOUNT = 3

export const DATE_TIME_FORMAT_YMD = 'YYYY/MM/DD'
export const DATE_TIME_FORMAT = 'YYYY/MM/DD HH:mm:ss'

export const ERROR_INSUFFICIENT_BALANCE = 70002
export const ERROR_STORE_DATA_TRANSFORMING = 20100111
export const ERROR_STORES_QUANTITY_REACH_UPPER_LIMIT = 10015 // 特殊服务项不足
export const ERROR_STORES_QUANTITY_PRODUCTS_LIMIT = 100151 // 推送商品次数不足
export const ERROR_CHECK_IS_VERIFY_EMAIL = 20030111
export const ERROR_INVALID_VERIFY_EMAIL = 10000015
export const BALANCE_NOT_ENOUGH = 30110115 // 余额不足状态码
export const STORE_NAME_ALREADY_EXIST = 20100101 // This store name is already exist
export const STORE_ADDRESS_ALREADY_EXIST = 20100102 // This store address is already exist
export const ERROR_PRODUCTS_STOCKED_EXPIRED = 100002001 // 订单包含已存放超期的商品

export const ONLINE_SERVICE_PATH = 'https://www.echatsoft.com/visitor/pc/chat.html'
export const CURRENCY_SYMBOL_CNY = 'CN ¥' // 人民币符号
export const CURRENCY_SYMBOL_USD = 'US $' // 美元符号

export const MILLISECONDS_OF_DAY = 86400000 // 一天的毫秒数

export const URL_REGEX = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www\.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w\-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[.!/\\\w]*))?)/
export const NON_HAN_REGEX = /^[^\u3400-\u4DB5\u4E00-\u9FEA\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA1F\uFA21\uFA23\uFA24\uFA27-\uFA29\u{20000}-\u{2A6D6}\u{2A700}-\u{2B734}\u{2B740}-\u{2B81D}\u{2B820}-\u{2CEA1}\u{2CEB0}-\u{2EBE0}]+$/u

export const NULL_SHOP: Shop = { // 作为一个过滤条件，如果 shopCode = '' ，不是查询 'Others' 店铺，而是所有店铺
  id: 0,
  shopCode: 'Others',
  shopName: 'Others',
  shopStatus: SHOP_STATUS.NORMAL,
  shopTitle: '这是一个空店铺，为没有店铺的订单挂个名字',
  shopType: SHOP_TYPE.BUCKY_SHOP,
  siteUrl: '',
}

export const INVALID_PROVINCE_AREA_ID = -1
